import { BaseballGameDataModelType } from "sb-resp-lib";

/**
 * BaseballGameData defines model for data necessary to visualize Baseballscoreboard
 * @typedef BaseballGameDataModel
 * @type {Object}
 * @property {eventId} id of event that is played
 * @property {participant1Name} string representing the name of the first team
 * @property {participant2Name} string representing the name of the second team
 * @property {homeInnings} array of numbers representing the scores of the first theam through all innings that have been played
 * @property {awayInnings} array of numbers representing the scores of the second theam through all innings that have been played
 * @property {homeTotalInnings} number showing the count of the runs made by the first team throughout the game
 * @property {awayTotalInnings} number showing the count of the runs made by the seond team throughout the game
 * @property {homeHits} number representing the hits of the first team through the game
 * @property {participant2THits} number representing the hits of the second team through the game
 * @property {currentInning} number representing the current Inning that is being played
 * @property {balls} number representing the count of balls thrown in the current inning
 * @property {strikes} number representing the count of strikes (for the currently batting player) for the inning that is in play
 * @property {outs} number representing the count of outs for the team that is batting in the ining that is in play
 * @property {currentTeamServing} number (0 or 1) representing which team is batting
 * @property {Base} number showing active bases
 */

export class BaseballGameDataModel {
    eventId: number;
    participant1Name: string;
    participant2Name: string;
    displayedInnings: string[];
    homeInnings: string[];
    awayInnings: string[];
    homeTotalInnings: number;
    awayTotalInnings: number;
    homeHits: number;
    awayHits: number;
    currentInning:number;
    balls: number;
    strikes: number;
    outs: number;
    base: number;
    currentTeamServing: number;

    constructor (data: BaseballGameDataModelType) {
        this.eventId = data.eventId;
        this.participant1Name = data.participant1Name;
        this.participant2Name = data.participant2Name;
        this.homeInnings = data.homeInnings;
        this.awayInnings = data.awayInnings;
        this.homeTotalInnings = data.homeTotalInnings;
        this.awayTotalInnings = data.awayTotalInnings;
        this.homeHits = data.homeHits;
        this.awayHits = data.awayHits;
        this.currentInning = data.currentInning;
        this.balls = data.balls;
        this.outs = data.outs;
        this.strikes = data.strikes;
        this.base = data.base;
        this.currentTeamServing = data.currentTeamServing;
        this.displayedInnings = data.displayedInnings;
    }

}